function slugify(str) {
  return str.trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-");
}
export {
  slugify
};
